import { Controller } from "@hotwired/stimulus"

export default class ExternalOptionsController extends Controller {
  static targets = ["status"]
  static values = { url: String, delay: { type: Number, default: 200 } }
  static outlets = ["coreui-multi-select", "coreui-autocomplete"]

  initialize() {
    this.sequence = 0
  }
  connect() {
    this.connected = true
    if (this.owner) this.load("")
  }
  coreuiMultiSelectOutletConnected(owner) {
    this.attach(owner)
  }
  coreuiAutocompleteOutletConnected(owner) {
    this.attach(owner)
  }
  coreuiMultiSelectOutletDisconnected() {
    this.cancel()
    this.owner = null
  }
  coreuiAutocompleteOutletDisconnected() {
    this.cancel()
    this.owner = null
  }
  attach(owner) {
    this.owner = owner
    if (this.connected) this.load("")
  }
  search({ detail: { value } }) {
    this.load(value)
  }

  load(query) {
    this.cancel()
    const sequence = this.sequence
    this.statusTarget.textContent = "Loading names…"
    this.timer = setTimeout(async () => {
      this.request = new AbortController()
      try {
        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("q", query)
        const response = await fetch(url, { signal: this.request.signal, headers: { Accept: "application/json" } })
        if (!response.ok) throw new Error("Unable to load names")
        const options = await response.json()
        if (!this.connected || sequence !== this.sequence || !this.owner?.instance) return
        const instance = this.owner.instance
        instance.update({
          options:
            instance.constructor.componentName === "autocomplete"
              ? options.map(({ value, text }) => ({ value, label: text }))
              : options,
        })
        this.statusTarget.textContent = options.length
          ? query.trim()
            ? `${options.length} matching names.`
            : `Preloaded ${options.length} names. Type to search for more.`
          : "No matching names. Try another search."
      } catch (error) {
        if (error.name !== "AbortError" && this.connected && sequence === this.sequence)
          this.statusTarget.textContent = "Names could not be loaded. Type again to retry."
      }
    }, this.delayValue)
  }

  cancel() {
    this.sequence++
    clearTimeout(this.timer)
    this.request?.abort()
  }
  disconnect() {
    this.connected = false
    this.cancel()
  }
}
